export default __webpack_public_path__ + "static/media/chevron-right.6ac53d90.svg";